module.exports = __webpack_public_path__ + "static/007232-5d8735320b129db17d929b09a3ea8e17.jpg";